<template>
  <div class="wrap bg-bonvoy-white">
    <div class="text-center">
      <h2 class="heading-caps">Calculate earning</h2>
      <h3 class="subheading">How to Boost Your Balance</h3>
      <p v-if="store.selectedCard.version === 'bevy'">Start by selecting your Elite status. Then estimate your spending and your number of stays by using the sliders or by entering the amounts manually. See how using your Card adds up to more points.</p>
      <p v-else-if="store.selectedCard.version === 'bevy'">Start by selecting your Elite status. Then estimate your spending by using the sliders or by entering the amounts manually. See how using your Card adds up to more points. <span class="no-wrap">Terms apply.*</span></p>
      <p v-else>Start by selecting your Elite status. Then estimate your spending by using the sliders or by entering the amounts manually. See how using your Card adds up to more points.</p>
    </div>
    <div class="earning-calculator">
      <tier-selector @tier-updated="handleTierUpdated" />

      <earning-calculator-section section="sec_1" :range-max="rangeMax" :range-step="rangeStep" :range-resolution="rangeResolution" @dollars-input="handleDollarsInput" />
      <earning-calculator-section section="sec_points" :range-max="25" :range-step="5" :range-resolution="5" @dollars-input="handleDollarsInput" points />
      <earning-calculator-section section="sec_2" :range-max="rangeMax_2" :range-step="rangeStep_2" :range-resolution="rangeResolution_2" @dollars-input="handleDollarsInput" />
      <earning-calculator-section section="sec_3" :range-max="rangeMax" :range-step="rangeStep" :range-resolution="rangeResolution" @dollars-input="handleDollarsInput" />

      <div class="d-flex align-items-center w-100 mt-3">
        <p class="bolder fz-xl m-0">&equals;</p>
        <div class="total-points-wrap d-flex justify-content-end">
          <p class="d-flex align-items-center">
            <span class="total-points bolder">{{ totalPointsFormatted }}</span>
            <span class="total-points-label ml-2">estimated points earned</span>
          </p>
        </div>
      </div>
    </div>
    <p :class="`text-center fz-3xs mt-2 ${store.selectedCard.version === 'business' ? 'mb-1' : ''}`">This scenario is for illustrative purposes only.</p>
    <p v-if="store.selectedCard.version === 'business'" class="text-center fz-3xs"><sup>‡</sup>Also includes wireless telephone services purchased directly from U.S. service providers and U.S. purchases for shipping.</p>
    <p v-if="store.selectedCard.version === 'brilliant'" class="text-center fz-3xs"><sup>†</sup>Flight must be booked directly with the airline to qualify.</p>
  </div>
  <p class="text-center sign-in w-100 pt-2 px-2 px-md-0"><a :href="store.content.url.sign_in" class="inline" target="_blank">Sign in</a> to your <span class="no-wrap">Marriott Bonvoy</span> account to see your total points.</p>
  <p v-if="store.selectedCard.version === 'consumer'" class="text-center fz-3xs px-2">The Marriott Bonvoy American Express Card is no longer available to new Card Members. Current <span class="no-wrap">Marriott Bonvoy</span> American Express Card Members can continue to use the Card and enjoy its many benefits.</p>
</template>

<script setup>
import TierSelector from './TierSelector';
import EarningCalculatorSection from './EarningCalculatorSection';
import { ref, computed, onMounted, onUpdated, nextTick } from 'vue';
import { useStore } from '../store';
import { q, numberWithCommas, numberNoCommas } from '../utilities';

const store = useStore();

const rangeMax = 50000;
const rangeStep = 10;
const rangeResolution = 10000;
const rangeMax_2 = ref(0);
const rangeStep_2 = ref(0);
const rangeResolution_2 = ref(0);

function updateTotalPoints() {
  nextTick(() => {
    store.totalPoints = 0;
    const pointsValueEls = q('.earning-calculator .points-value');
    pointsValueEls.map(el => {
      store.totalPoints += numberNoCommas(el.textContent);
    });
  });
}

let widestLabelWidth = 0;

function updateLabelWidths() {
  q('.earning-calculator .value-label').map(el => {
    el.style.width = 'auto';
    widestLabelWidth = 0;
  });
  nextTick(() => {
    q('.earning-calculator .value-label').map(el => {
      const elWidth = Math.ceil(el.getBoundingClientRect().width);
      if (elWidth > 0 && elWidth > widestLabelWidth) {
        widestLabelWidth = elWidth;
      }
    });
    q('.earning-calculator .value-label').map(el => {
      el.style.width = widestLabelWidth + 'px';
    });
  });
}

const totalPointsFormatted = computed(() => numberWithCommas(store.totalPoints));

function handleTierUpdated() {
  updateTotalPoints();
  updateLabelWidths();
}

function handleDollarsInput() {
  updateTotalPoints();
}

function setRangeAttr() {
  if (store.selectedCard.version === 'bevy') {
    rangeMax_2.value = 15000;
    rangeStep_2.value = 3;
    rangeResolution_2.value = 3000;
  } else {
    rangeMax_2.value = rangeMax;
    rangeStep_2.value = rangeStep;
    rangeResolution_2.value = rangeResolution;
  }
}

onMounted(() => {
  updateLabelWidths();
  setRangeAttr();
});

onUpdated(() => {
  setRangeAttr();
});

window.addEventListener('resize', () => {
  updateLabelWidths();
});
</script>
